var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoScroll = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 15.5V8.5C15 6.567 13.433 5 11.5 5C9.567 5 8 6.567 8 8.5V15.5C8 17.433 9.567 19 11.5 19C13.433 19 15 17.433 15 15.5ZM11.5 3C8.46243 3 6 5.46243 6 8.5V15.5C6 18.5376 8.46243 21 11.5 21C14.5376 21 17 18.5376 17 15.5V8.5C17 5.46243 14.5376 3 11.5 3Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 11C10.6716 11 10 11.6716 10 12.5V15.5C10 16.3284 10.6716 17 11.5 17C12.3284 17 13 16.3284 13 15.5V12.5C13 11.6716 12.3284 11 11.5 11Z",
    fill: "#fff"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoScroll);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_scroll.28e727660e3e15636d1c5c48d21af7e4.svg";